import { Collapse, CollapseItem, Button, Popover, Select, Option, } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { EventBus } from '@/services/Event.js';

export default {
    name: 'RacesView',
    props: ['races'],
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Button.name]: Button,
        [Popover.name]: Popover,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            activeRaceId: null
        };
    },
    computed: {
        isAnyRacesLoaded() {
            return !this.races || !this.races.length || this.races[0].id;
        }
    },
    methods: {
        loadRaceResult(isDownload) {
            if (isDownload) {
                EventBus.$emit('race-result-download', this.activeRaceId);
            } else {
                EventBus.$emit('view-race-results', this.activeRaceId);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/user/ranking/races-view/races-view.js